<template>
  <section v-loading="listLoading" class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.userId" placeholder="用户 ID" />
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.mark" clearable placeholder="标记类型" @change="list">
            <el-option label="涉黄风险" value="sexual_risk" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.source" clearable placeholder="来源" @change="list">
            <el-option label="千问" value="qwen" />
            <el-option label="违禁词" value="forbidden_word" />
            <el-option label="本地涉黄规则" value="local_sexual" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }" class="page-section">
      <el-table :data="results" border>
        <el-table-column prop="id" label="ID" width="90" />
        <el-table-column prop="userId" label="用户ID" width="90" />
        <el-table-column label="用户" min-width="160">
          <template slot-scope="{ row }">
            <span>{{ row.user && row.user.nickname ? row.user.nickname : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mark" label="标记" width="120" />
        <el-table-column prop="sexualRiskMarkCount" label="近7天标记数" width="110" />
        <el-table-column label="处罚阶段" width="120">
          <template slot-scope="{ row }">
            <el-tag :type="penaltyStageType(row.sexualRiskPenaltyStage)" size="mini">
              {{ penaltyStageLabel(row.sexualRiskPenaltyStage) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="source" label="来源" width="120" />
        <el-table-column prop="entityType" label="内容类型" width="100" />
        <el-table-column prop="entityId" label="内容ID" width="100" />
        <el-table-column prop="reason" label="原因" min-width="260" />
        <el-table-column label="时间" width="170">
          <template slot-scope="{ row }">
            {{ row.createTime | formatDate }}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div ref="pagebar" class="pagebar">
      <el-pagination
        :page-sizes="[20, 50, 100, 300]"
        :current-page="page.page"
        :page-size="page.limit"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </div>
  </section>
</template>

<script>
import mainHeight from "@/utils/mainHeight";

export default {
  name: "UserMark",
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {},
      filters: {},
    };
  },
  mounted() {
    mainHeight(this);
    if (this.$route.query.userId) {
      this.filters.userId = this.$route.query.userId;
    }
    this.list();
  },
  methods: {
    async list() {
      this.listLoading = true;
      const params = {
        user_id: this.filters.userId,
        mark: this.filters.mark,
        source: this.filters.source,
        page: this.page.page,
        limit: this.page.limit,
      };
      try {
        const data = await this.axios.form("/api/admin/user-mark/list", params);
        this.results = data.results;
        this.page = data.page;
      } finally {
        this.listLoading = false;
      }
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    penaltyStageLabel(stage) {
      return (stage && stage.label) || "正常";
    },
    penaltyStageType(stage) {
      const code = stage && stage.code;
      if (code === "permanent") {
        return "danger";
      }
      if (code === "temporary") {
        return "warning";
      }
      if (code === "warning") {
        return "";
      }
      return "success";
    },
  },
};
</script>

<style scoped lang="scss">
.page-section {
  overflow-y: auto;
}
</style>
